import { ErrorBoundary } from "react-error-boundary";
import { ErrorScreen } from "../pages/Dashboard/ErrorScreen";
import { useNavigate } from 'react-router-dom'

export default function ReactErrorBoundary(props) {
    
    const navigate = useNavigate()

    return (
        <ErrorBoundary
            FallbackComponent={ErrorScreen}
            onError={(error, errorInfo) => {
            }}
            onReset={() => {
                // reloading the page to restore the initial state
                window.location.reload();
                // navigate("/app")
            }}
        >
            {props.children}
        </ErrorBoundary>
    );
}